import React from "react";
import { MdQuiz } from "react-icons/md";

interface QuizOption {
  quizOptionId: number;
  twOption: string;
  enOption: string;
  isCorrect: number;
  enQuestion: string;
  enAnswer: string;
}

export interface ISelectedOption {
  quizOptionId: number;
  isCorrect: number;
  order: number;
  enQuestion: string;
  enAnswer: string;
  quizQuestionId: number;
}

interface IQuestionnarie {
  questionKey: number;
  questionId: number;
  question?: string;
  options: QuizOption[];
  handleSelectedOption: (option: ISelectedOption) => void;
  selectedOption: ISelectedOption | null;
  showHeader?: boolean;
  instruction?: string;
}

const QuizQuestionnaire: React.FC<IQuestionnarie> = ({
  questionId,
  question,
  options,
  selectedOption,
  handleSelectedOption,
  questionKey,
}) => {
  return (
    <div className="w-full px-4" id={`question-${questionKey}`}>
      <MdQuiz className="size-10 text-(--primary-green) mx-auto mb-5" />
      <h2 className="text-center text-xl font-bold leading-snug text-black">{question}</h2>

      <div className="mt-8 space-y-3">
        {options?.map((option) => {
          const isSelected = selectedOption?.quizOptionId === option.quizOptionId;
          const inputId = `option-${questionId}-${option.quizOptionId}`;

          return (
            <label
              key={option.quizOptionId}
              htmlFor={inputId}
              className={`flex cursor-pointer items-center gap-3 rounded-xl border bg-white px-4 py-4 transition-colors ${isSelected ? "border-(--button-green)" : "border-[#E0E0E0]"
                }`}
            >
              <div className="relative flex h-5 w-5 shrink-0 items-center justify-center">
                <input
                  type="radio"
                  id={inputId}
                  name={`question-${questionId}`}
                  className="peer absolute h-full w-full cursor-pointer opacity-0"
                  checked={isSelected}
                  onChange={() => {
                    handleSelectedOption({
                      quizOptionId: option.quizOptionId,
                      isCorrect: option.isCorrect,
                      order: questionKey,
                      enQuestion: option.enQuestion,
                      enAnswer: option.enOption,
                      quizQuestionId: questionId,
                    });
                  }}
                />
                <div
                  className={`flex h-5 w-5 items-center justify-center rounded-full border-2 transition-colors ${isSelected
                    ? "border-(--button-green) bg-(--button-green)"
                    : "border-[#D1D1D1] bg-white"
                    }`}
                >
                  {isSelected ? <span className="h-2 w-2 rounded-full bg-white" /> : null}
                </div>
              </div>
              <span className="text-left font-normal text-base text-black">{option.twOption}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default QuizQuestionnaire;
